import React, { useEffect, useState } from "react";
import { BsChevronCompactLeft } from "react-icons/bs";
import { BsChevronCompactRight } from "react-icons/bs";

import slides from "../assets/slideshow";
import logoimg1 from "../assets/MBRS_2023_IndividualMemberLogo_Color.png";
import logoimg2 from "../assets/engineerlogo.png";

const Slideshow = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    slides.forEach((img) => {
      const image = new Image();
      image.src = img;
    });
  }, []);

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  return (
    <div name="Home" className="relative w-full h-screen">
      <div className="max-h-screen w-full m-auto bg-gray-900/90 absolute flex flex-col">
        <div className="relative w-full h-screen group overflow-hidden grow">
          <div className="absolute inset-0 bg-gray-900" aria-hidden="true" />
          {slides.map((slide, slideIndex) => (
            <img
              key={slide}
              src={slide}
              alt=""
              className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-500 ${
                slideIndex === currentIndex ? "opacity-100" : "opacity-0"
              }`}
            />
          ))}
          <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 z-10 text-2xl rounded-full p-2 bg-black/50 text-white cursor-pointer">
            <BsChevronCompactLeft onClick={prevSlide} size={30} />
          </div>
          <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 z-10 text-2xl rounded-full p-2 bg-black/50 text-white cursor-pointer">
            <BsChevronCompactRight onClick={nextSlide} size={30} />
          </div>
        </div>
        <div className="h-[80px] w-full bg-white flex items-center">
          <img className="mx-auto w-16" src={logoimg1} alt=""></img>
          <div className="w-full sm:w-2/3 sm:pl-32">
            <p className="font-bold text-center text-xs md:text-lg">
              Process, environmental, health and safety engineering for
              industrial, commercial, institutional and government clients.
            </p>
          </div>
          <img className="mx-auto w-24 sm:w-48" src={logoimg2} alt=""></img>
        </div>
      </div>
    </div>
  );
};

export default Slideshow;
